import { Country } from '../types/country';

const countries: Country[] = [
  {
    code: 'US',
    name: 'United States of America',
    continent: 'North America',
    marketCap: 40297.98,
  },
  {
    code: 'CA',
    name: 'Canada',
    continent: 'North America',
    marketCap: 2744.72,
  },
  {
    code: 'MX',
    name: 'Mexico',
    continent: 'North America',
    marketCap: 454.37,
  },
  {
    code: 'GB',
    name: 'United Kingdom',
    continent: 'Europe',
    marketCap: 3095.98,
  },
  {
    code: 'FR',
    name: 'France',
    continent: 'Europe',
    marketCap: 2365.95,
  },
  {
    code: 'DE',
    name: 'Germany',
    continent: 'Europe',
    marketCap: 1889.66,
  },
  {
    code: 'CH',
    name: 'Switzerland',
    continent: 'Europe',
    marketCap: 1830.52,
  },
  {
    code: 'ES',
    name: 'Spain',
    continent: 'Europe',
    marketCap: 665.5,
  },
  {
    code: 'NL',
    name: 'Netherlands',
    continent: 'Europe',
    marketCap: 1100.11,
  },
  {
    code: 'IT',
    name: 'Italy',
    continent: 'Europe',
    marketCap: 587.31,
  },
  {
    code: 'BE',
    name: 'Belgium',
    continent: 'Europe',
    marketCap: 321.09,
  },
  {
    code: 'NO',
    name: 'Norway',
    continent: 'Europe',
    marketCap: 295.55,
  },
  {
    code: 'SE',
    name: 'Sweden',
    continent: 'Europe',
    marketCap: 289.88,
  },
  {
    code: 'DK',
    name: 'Denmark',
    continent: 'Europe',
    marketCap: 151.35,
  },
  {
    code: 'IE',
    name: 'Ireland',
    continent: 'Europe',
    marketCap: 110.15,
  },
  {
    code: 'PT',
    name: 'Portugal',
    continent: 'Europe',
    marketCap: 61.93,
  },
  {
    code: 'FI',
    name: 'Finland',
    continent: 'Europe',
    marketCap: 20.34,
  },
  {
    code: 'SK',
    name: 'Slovak Republic',
    continent: 'Europe',
    marketCap: 5.38,
  },
  {
    code: 'UA',
    name: 'Ukraine',
    continent: 'Europe',
    marketCap: 4.42,
  },
  {
    code: 'RS',
    name: 'Serbia',
    continent: 'Europe',
    marketCap: 4.06,
  },
  {
    code: 'RU',
    name: 'Russian Federation',
    continent: 'Europe',
    marketCap: 530.1,
  },
  {
    code: 'TR',
    name: 'Turkey',
    continent: 'Europe',
    marketCap: 330.01,
  },
  {
    code: 'PL',
    name: 'Poland',
    continent: 'Europe',
    marketCap: 147.66,
  },
  {
    code: 'AT',
    name: 'Austria',
    continent: 'Europe',
    marketCap: 123.05,
  },
  {
    code: 'GR',
    name: 'Greece',
    continent: 'Europe',
    marketCap: 59.04,
  },
  {
    code: 'LU',
    name: 'Luxembourg',
    continent: 'Europe',
    marketCap: 50.9,
  },
  {
    code: 'KZ',
    name: 'Kazakhstan',
    continent: 'Europe',
    marketCap: 45.77,
  },
  {
    code: 'RO',
    name: 'Romania',
    continent: 'Europe',
    marketCap: 28.98,
  },
  {
    code: 'CZ',
    name: 'Czech Republic',
    continent: 'Europe',
    marketCap: 28.81,
  },
  {
    code: 'HU',
    name: 'Hungary',
    continent: 'Europe',
    marketCap: 23.87,
  },
  {
    code: 'CN',
    name: 'China',
    continent: 'Asia',
    marketCap: 11469.35,
  },
  {
    code: 'JP',
    name: 'Japan',
    continent: 'Asia',
    marketCap: 5380.48,
  },
  {
    code: 'HK',
    name: 'Hong Kong, SAR China',
    continent: 'Asia',
    marketCap: 4566.81,
  },
  {
    code: 'TW',
    name: 'Taiwan',
    continent: 'Asia',
    marketCap: 2261.86,
  },
  {
    code: 'IN',
    name: 'India',
    continent: 'Asia',
    marketCap: 3603.48,
  },
  {
    code: 'KR',
    name: 'Korea (South)',
    continent: 'Asia',
    marketCap: 1644.51,
  },
  {
    code: 'IR',
    name: 'Iran, Islamic Republic of',
    continent: 'Asia',
    marketCap: 1613.04,
  },
  {
    code: 'SG',
    name: 'Singapore',
    continent: 'Asia',
    marketCap: 619.36,
  },
  {
    name: 'Indonesia',
    code: 'ID',
    continent: 'Asia',
    marketCap: 610.29,
  },
  {
    code: 'TH',
    name: 'Thailand',
    continent: 'Asia',
    marketCap: 604.36,
  },
  {
    code: 'MY',
    name: 'Malaysia',
    continent: 'Asia',
    marketCap: 381.21,
  },
  {
    code: 'PH',
    name: 'Philippines',
    continent: 'Asia',
    marketCap: 238.58,
  },
  {
    code: 'VN',
    name: 'Viet Nam',
    continent: 'Asia',
    marketCap: 170.15,
  },
  {
    code: 'BD',
    name: 'Bangladesh',
    continent: 'Asia',
    marketCap: 42.89,
  },
  {
    code: 'PK',
    name: 'Pakistan',
    continent: 'Asia',
    marketCap: 28.71,
  },
  {
    code: 'UZ',
    name: 'Uzbekistan',
    continent: 'Asia',
    marketCap: 5.19,
  },
  {
    code: 'BR',
    name: 'Brazil',
    continent: 'Central and South America',
    marketCap: 794.42,
  },
  {
    code: 'CL',
    name: 'Chile',
    continent: 'Central and South America',
    marketCap: 285.23,
  },
  {
    code: 'PE',
    name: 'Peru',
    continent: 'Central and South America',
    marketCap: 71.31,
  },
  {
    code: 'CO',
    name: 'Colombia',
    continent: 'Central and South America',
    marketCap: 68.41,
  },
  {
    code: 'AR',
    name: 'Argentina',
    continent: 'Central and South America',
    marketCap: 52.95,
  },
  {
    code: 'VE',
    name: 'Venezuela',
    continent: 'Central and South America',
    marketCap: 3.98,
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
    continent: 'Middle East and Africa',
    marketCap: 2638.59,
  },
  {
    code: 'ZA',
    name: 'South Africa',
    continent: 'Middle East and Africa',
    marketCap: 1171.75,
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
    continent: 'Middle East and Africa',
    marketCap: 873.56,
  },
  {
    code: 'QA',
    name: 'Qatar',
    continent: 'Middle East and Africa',
    marketCap: 166.78,
  },
  {
    code: 'KW',
    name: 'Kuwait',
    continent: 'Middle East and Africa',
    marketCap: 152.68,
  },
  {
    code: 'NG',
    name: 'Nigeria',
    continent: 'Middle East and Africa',
    marketCap: 91.44,
  },
  {
    code: 'MA',
    name: 'Morocco',
    continent: 'Middle East and Africa',
    marketCap: 53.71,
  },
  {
    code: 'EG',
    name: 'Egypt',
    continent: 'Middle East and Africa',
    marketCap: 38.85,
  },
  {
    code: 'BW',
    name: 'Botswana',
    continent: 'Middle East and Africa',
    marketCap: 31.02,
  },
  {
    code: 'BH',
    name: 'Bahrain',
    continent: 'Middle East and Africa',
    marketCap: 30.26,
  },
  {
    code: 'JO',
    name: 'Jordan',
    continent: 'Middle East and Africa',
    marketCap: 25.43,
  },
  {
    code: 'LB',
    name: 'Lebanon',
    continent: 'Middle East and Africa',
    marketCap: 10.58,
  },
  {
    code: 'CI',
    name: "Cote d'Ivoire",
    continent: 'Middle East and Africa',
    marketCap: 7.33,
  },
  {
    code: 'IL',
    name: 'Israel',
    continent: 'Middle East and Africa',
    marketCap: 269.64,
  },
  {
    code: 'AU',
    name: 'Australia',
    continent: 'Oceania',
    marketCap: 1679.17,
  },
  {
    code: 'NZ',
    name: 'New Zealand',
    continent: 'Oceania',
    marketCap: 97.55,
  },
  // Missing countries from fin-gen src/fin_gen/core/countries.py
  {
    code: 'AD',
    name: 'Andorra',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'AF',
    name: 'Afghanistan',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'AG',
    name: 'Antigua and Barbuda',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'AI',
    name: 'Anguilla',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'AL',
    name: 'Albania',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'AM',
    name: 'Armenia',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'AN',
    name: 'Netherlands Antilles',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'AO',
    name: 'Angola',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'AQ',
    name: 'Antarctica',
    continent: 'Antarctica',
    marketCap: 0,
  },
  {
    code: 'AS',
    name: 'American Samoa',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'AW',
    name: 'Aruba',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'AX',
    name: 'Åland Islands',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'AZ',
    name: 'Azerbaijan',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'BB',
    name: 'Barbados',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'BG',
    name: 'Bulgaria',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'BI',
    name: 'Burundi',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'BJ',
    name: 'Benin',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'BM',
    name: 'Bermuda',
    continent: 'North America',
    marketCap: 0,
  },
  {
    code: 'BN',
    name: 'Brunei Darussalam',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'BO',
    name: 'Bolivia',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'BS',
    name: 'Bahamas',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'BT',
    name: 'Bhutan',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'BV',
    name: 'Bouvet Island',
    continent: 'Antarctica',
    marketCap: 0,
  },
  {
    code: 'BY',
    name: 'Belarus',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'BZ',
    name: 'Belize',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'CD',
    name: 'Congo, Democratic Republic of the',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'CF',
    name: 'Central African Republic',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'CG',
    name: 'Congo, Republic of the',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'CK',
    name: 'Cook Islands',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'CM',
    name: 'Cameroon',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'CR',
    name: 'Costa Rica',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'CS',
    name: 'Serbia and Montenegro',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'CU',
    name: 'Cuba',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'CV',
    name: 'Cape Verde',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'CX',
    name: 'Christmas Island',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'CY',
    name: 'Cyprus',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'DJ',
    name: 'Djibouti',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'DM',
    name: 'Dominica',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'DO',
    name: 'Dominican Republic',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'DZ',
    name: 'Algeria',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'EC',
    name: 'Ecuador',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'EE',
    name: 'Estonia',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'EH',
    name: 'Western Sahara',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'ER',
    name: 'Eritrea',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'ET',
    name: 'Ethiopia',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'FJ',
    name: 'Fiji',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'FK',
    name: 'Falkland Islands (Malvinas)',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'FM',
    name: 'Micronesia, Federated States of',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'FO',
    name: 'Faroe Islands',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'GA',
    name: 'Gabon',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'GD',
    name: 'Grenada',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'GE',
    name: 'Georgia',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'GF',
    name: 'French Guiana',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'GG',
    name: 'Guernsey',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'GH',
    name: 'Ghana',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'GI',
    name: 'Gibraltar',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'GL',
    name: 'Greenland',
    continent: 'North America',
    marketCap: 0,
  },
  {
    code: 'GM',
    name: 'Gambia',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'GN',
    name: 'Guinea',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'GP',
    name: 'Guadeloupe',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'GQ',
    name: 'Equatorial Guinea',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
    continent: 'Antarctica',
    marketCap: 0,
  },
  {
    code: 'GT',
    name: 'Guatemala',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'GU',
    name: 'Guam',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'GW',
    name: 'Guinea-Bissau',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'GY',
    name: 'Guyana',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'HM',
    name: 'Heard Island and McDonald Islands',
    continent: 'Antarctica',
    marketCap: 0,
  },
  {
    code: 'HN',
    name: 'Honduras',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'HR',
    name: 'Croatia',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'HT',
    name: 'Haiti',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'IQ',
    name: 'Iraq',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'IS',
    name: 'Iceland',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'JE',
    name: 'Jersey',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'JM',
    name: 'Jamaica',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'KE',
    name: 'Kenya',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'KG',
    name: 'Kyrgyzstan',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'KH',
    name: 'Cambodia',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'KI',
    name: 'Kiribati',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'KM',
    name: 'Comoros',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'KN',
    name: 'Saint Kitts and Nevis',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'KP',
    name: "Korea, Democratic People's Republic of",
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'KY',
    name: 'Cayman Islands',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'LA',
    name: "Lao People's Democratic Republic",
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'LC',
    name: 'Saint Lucia',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'LR',
    name: 'Liberia',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'LS',
    name: 'Lesotho',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'LT',
    name: 'Lithuania',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'LV',
    name: 'Latvia',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'LY',
    name: 'Libya',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'MC',
    name: 'Monaco',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'MD',
    name: 'Moldova, Republic of',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'ME',
    name: 'Montenegro',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'MG',
    name: 'Madagascar',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'MH',
    name: 'Marshall Islands',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'MK',
    name: 'North Macedonia',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'ML',
    name: 'Mali',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'MM',
    name: 'Myanmar',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'MN',
    name: 'Mongolia',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'MO',
    name: 'Macau',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'MP',
    name: 'Northern Mariana Islands',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'MQ',
    name: 'Martinique',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'MR',
    name: 'Mauritania',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'MS',
    name: 'Montserrat',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'MT',
    name: 'Malta',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'MU',
    name: 'Mauritius',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'MV',
    name: 'Maldives',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'MW',
    name: 'Malawi',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'MZ',
    name: 'Mozambique',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'NA',
    name: 'Namibia',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'NC',
    name: 'New Caledonia',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'NE',
    name: 'Niger',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'NF',
    name: 'Norfolk Island',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'NI',
    name: 'Nicaragua',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'NP',
    name: 'Nepal',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'NR',
    name: 'Nauru',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'NU',
    name: 'Niue',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'OM',
    name: 'Oman',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'PA',
    name: 'Panama',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'PF',
    name: 'French Polynesia',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'PG',
    name: 'Papua New Guinea',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'PM',
    name: 'Saint Pierre and Miquelon',
    continent: 'North America',
    marketCap: 0,
  },
  {
    code: 'PN',
    name: 'Pitcairn',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
    continent: 'North America',
    marketCap: 0,
  },
  {
    code: 'PS',
    name: 'Palestinian Territory, Occupied',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'PW',
    name: 'Palau',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'PY',
    name: 'Paraguay',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'RE',
    name: 'Reunion',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'RW',
    name: 'Rwanda',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'SB',
    name: 'Solomon Islands',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'SC',
    name: 'Seychelles',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'SD',
    name: 'Sudan',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'SH',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'SI',
    name: 'Slovenia',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'SJ',
    name: 'Svalbard and Jan Mayen',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'SL',
    name: 'Sierra Leone',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'SM',
    name: 'San Marino',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'SN',
    name: 'Senegal',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'SO',
    name: 'Somalia',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'SR',
    name: 'Suriname',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'ST',
    name: 'Sao Tome and Principe',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'SV',
    name: 'El Salvador',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'SY',
    name: 'Syrian Arab Republic',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'SZ',
    name: 'Eswatini',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'TC',
    name: 'Turks and Caicos Islands',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'TD',
    name: 'Chad',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'TF',
    name: 'French Southern Territories',
    continent: 'Antarctica',
    marketCap: 0,
  },
  {
    code: 'TG',
    name: 'Togo',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'TJ',
    name: 'Tajikistan',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'TK',
    name: 'Tokelau',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'TL',
    name: 'Timor-Leste',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'TM',
    name: 'Turkmenistan',
    continent: 'Asia',
    marketCap: 0,
  },
  {
    code: 'TN',
    name: 'Tunisia',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'TO',
    name: 'Tonga',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'TT',
    name: 'Trinidad and Tobago',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'TV',
    name: 'Tuvalu',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'TZ',
    name: 'Tanzania, United Republic of',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'UG',
    name: 'Uganda',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'UM',
    name: 'United States Minor Outlying Islands',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'UY',
    name: 'Uruguay',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'VA',
    name: 'Holy See (Vatican City State)',
    continent: 'Europe',
    marketCap: 0,
  },
  {
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'VG',
    name: 'Virgin Islands (British)',
    continent: 'Central and South America',
    marketCap: 0,
  },
  {
    code: 'VI',
    name: 'Virgin Islands (U.S.)',
    continent: 'North America',
    marketCap: 0,
  },
  {
    code: 'WF',
    name: 'Wallis and Futuna',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'WS',
    name: 'Samoa',
    continent: 'Oceania',
    marketCap: 0,
  },
  {
    code: 'YE',
    name: 'Yemen',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'YT',
    name: 'Mayotte',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'ZM',
    name: 'Zambia',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
  {
    code: 'ZW',
    name: 'Zimbabwe',
    continent: 'Middle East and Africa',
    marketCap: 0,
  },
];

export default countries;
